<div class="modal-popup">
  <div id="fsModalContent" class="modal-popup-content">
    <div class="dtt-sharepoint-file-container">

      <div class="workspace-settings-modal-title">
        Push to Teams
      </div>

      <div style="display:flex; flex-direction:row;">
        <div class="dtt-team-header">
          MS Team:
        </div>
        <div id="teamDD">
          <div>
            <kendo-dropdownlist [data]="dropdownData"
                                [textField]="'teamName'"
                                [(ngModel)]="selectedTeamId"
                                (valueChange)="onSelectMSTeam($event)"
                                [valueField]="'id'">
            </kendo-dropdownlist>
          </div>

        </div>

        <div id="noTeamDD" style="display:none;">
          No Teams available for selection.
        </div>
      </div>
        <hr />

        <div class="workspace-spinner" style="text-align:center;">
          <div class="fa fa-spinner fa-spin-details"></div>
        </div>

        <div id="treelist">
          <div class="k-content">

            <div id="pushTitle">
              {{pushTitle}}
              <!--Select folder to push files to-->
            </div>

            <div id="pushGrid" class="demo-section k-content">
              <kendo-treeview [nodes]="treeviewData"
                              textField="name"
                              kendoTreeViewExpandable
                              kendoTreeViewHierarchyBinding
                              [hasChildren]="hasChildren"
                              [children]="fetchChildren">
                <ng-template kendoTreeViewNodeTemplate let-dataItem>
                  <span class="k-icon {{'k-i-folder'}}"></span>
                  {{dataItem.name}}
                </ng-template>
              </kendo-treeview>
            </div>

            <div id="documentgrid" class="list-documents">
            </div>

          </div>

        </div>
      

      <div style="margin-top:30px;">
        <div class="row" style="padding-left: 200px; margin-top:10px;">
          <div id="uploadColumn" class="column">
            <button type="button" class="taskbutton-ok" name="uploadButton" id="uploadButton" (click)="uploadFiles()"><img src="../../../../assets/images/workbench/Tasks_Ok.svg"></button>
          </div>
          <div class="column">
            <button id="button" class="taskbutton-cancel" (click)="closePopupDiv($event)"><img src="../../../../assets/images/workbench/Tasks_Cancel.svg"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


